import i18next from 'i18next';

import { isEmpty } from 'helpers/utils';
import {
  enabledPortfolioAssetsSelector,
  userMarginModeSelector,
} from 'selectors/otherSelectors';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';

import { EnabledPFs, getWarningMessage } from '../MarginTypeWarning/util';
import styles from './ChartScreen.module.scss';

const warningMessageGenerator = (code: string) => i18next.t(`trading:blocked.${code}`);

const WarningMessage = () => {
  const userMarginMode = useAppSelector(userMarginModeSelector);
  const selectedProduct = useAppSelector(selectedProductSelector);
  const enabledPfs = useAppSelector(enabledPortfolioAssetsSelector) as EnabledPFs;

  const warningMsg = getWarningMessage({
    marginMode: userMarginMode as string,
    selectedProduct: selectedProduct || {},
    enabledPfs,
  });

  if (isEmpty(warningMsg)) return null;

  return <div className={styles.errorMessage} data-palette="WarningMessage">{warningMessageGenerator(warningMsg)}</div>;
};

export default WarningMessage;
